import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import { Patterns } from 'src/app/helpers/patterns';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { UsersService } from 'src/app/shared/services/users.service';

export interface DialogData {
  userName: string;
}

@Component({
  selector: 'app-change-username',
  templateUrl: './change-username.component.html'
})
export class ChangeUsernameComponent implements OnInit {

  formGroup!: FormGroup;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<ChangeUsernameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: UsersService,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    private swalService: SwalService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  submit() {
    if (this.formGroup.valid) {
      this.loading = true;
      const username = {
        userName: this.formGroup.controls['UserName'].value
      };
      this.service.changeUserName(username).subscribe(
        (data: any) => {
          this.loading = false;
          this.swalService.swalSuccess(this.translate.instant('auth.Username-updated-successfully'))
            .then((result: any) => {
              this.dialogRef.close(true);
              this.authenticationService.logout();
            });
        },
        (error: any) => {
          this.loading = false;
          this.handleErrors(error.detail);
        });
    }
  }

  initForm() {
    this.formGroup = this.formBuilder.group({
      UserName: [this.data.userName, [
        Validators.required,
        CustomValidator.noWhiteSpace,
        // Validators.pattern(Patterns.userName)
      ]]
    });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      if (error.ErrorCode === 'Repeated') {
        this.formGroup.controls[error.ErrorDetail].setErrors({ notUniqe: true });
      } else {
        this.swalService.swalFailed(error.Error);
      }
    });
  }

}
